import React from "react";
import Image from "components/image";
import Slider from "react-slick";

const TrustedBy = () => {

    const trustedByContent = [
        { url: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/PRINT.png?v=1758814545", alt: "Sam's Club" },
        { url: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/5c324d386f05bab61381bc39cda36cea083b16fc.png?v=1758814546", alt: "Walmart" },
        { url: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/PRINT_1.png?v=1758814546", alt: "LOWE'S" },
        { url: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/f5fd585d67fc404d717fa2e5b4bbcf0d3a8476e7.png?v=1758814546", alt: "AUTOZONE" },
        { url: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/PRINT_2.png?v=1758814545", alt: "TRACTOR SUPPLY CO" }
    ];
    const sliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 4000,
        slidesToShow: 5,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 0,
                    cssEase: "linear",
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 0,
                    cssEase: "linear",
                }
            }
        ],
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 500,
    };
    return (
        <div
            className="companies">
            <p className="companies__title">Trusted By</p>
            <div className="companies__list">
                <Slider {...sliderSettings}>
                    {trustedByContent.map((item, index) => (
                        <div key={`company-${item?.url ?? index}-${index}`} className="company">
                            <div className="company__image">
                                <Image image={item.url} alt={item.alt} />
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default TrustedBy;